module.exports = __webpack_public_path__ + "static/media/car10.5f2c6938.JPEG";